import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from '@material-ui/icons';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import FormTextInput from 'components/FormTextInput/FormTextInput';

const FacebookPixelModule = ({ classes, handleModuleUpdate, module }) => {
  const { t } = useTranslation();

  if (!module) {
    return (
      <div>
        {t('brands.newBrandForm.moduleNotLoaded', {
          defaultValue: '{{moduleName}} not loaded.',
          moduleName: 'FacebookPixelModule',
        })}
      </div>
    );
  }

  return (
    <Fragment>
      <FormControlLabel
        control={
          <Checkbox
            checked={module.enabled}
            onChange={() =>
              handleModuleUpdate({
                ...module,
                enabled: !module.enabled,
              })
            }
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
              root: classes.checkRoot,
            }}
          />
        }
        label={t('brands.newBrandForm.useFP', 'Używaj Facebook Pixel')}
      />
      <FormTextInput
        label="Facebook Pixel ID"
        classes={classes}
        name="facebookPixel"
        value={module.id}
        maxLength={64}
        handleChange={e =>
          handleModuleUpdate({
            ...module,
            id: e.target.value,
          })
        }
        inputSize={12}
      />
    </Fragment>
  );
};

export default FacebookPixelModule;
